var map = {
	"./bg-3.jpg": "./app/packs/images/bg-3.jpg",
	"./blank.png": "./app/packs/images/blank.png",
	"./dcpl.png": "./app/packs/images/dcpl.png",
	"./deepak_nitrite_logo.png": "./app/packs/images/deepak_nitrite_logo.png",
	"./dpl_logo.png": "./app/packs/images/dpl_logo.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./app/packs/images sync recursive ^\\.\\/.*$";